import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Colors } from "../../../Constants/colors";
import { FontSize } from "../../../Constants/Enums/Size.enums";
import { getValue } from "../../../utils/object.utils";
ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  studentCountByGender: {
    boysCount: number;
    girlsCount: number;
  };
}

export const StudentsGenderGraph = ({ studentCountByGender }: Props) => {
  const boysCount = getValue(studentCountByGender, "boysCount", 0);
  const girlsCount = getValue(studentCountByGender, "girlsCount", 0);

  const data = {
    labels: ["Boy", "Girl"],
    datasets: [
      {
        label: "Total number",
        data: [boysCount, girlsCount],
        backgroundColor: ["rgba(54, 162, 235, 0.8)", "rgba(255, 99, 132, 0.8)"],
        borderColor: ["rgba(54, 162, 235, 1)", "rgba(255, 99, 132, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Distribution of Students by Gender",
      },
    },
  };
  return (
    <div>
      <Doughnut data={data} options={options} />
      <div className="flex mt-5">
        <div className="text-left flex-1">
          <p style={{ fontSize: FontSize.F14, color: Colors.Grey }}>
            Girl student
          </p>
          <p className="text-bold">{girlsCount}</p>
        </div>
        <div
          className="text-right flex-1"
          style={{
            borderLeft: `2px solid ${Colors.LightAshRose}`,
          }}
        >
          <p style={{ fontSize: FontSize.F14, color: Colors.Grey }}>
            Boy student
          </p>
          <p className="text-bold">{boysCount}</p>
        </div>
      </div>
    </div>
  );
};
